import { atom } from "jotai";

export const accountSettingsModalOpenAtom = atom(false);
